import { PageHeader, RoleChip, StatusChip } from "@jod/ui";
import { createFileRoute } from "@tanstack/react-router";
import { OwnerDataTable as DataTable } from "../../components/owner-data-table.tsx";
import { useOwnerState } from "../../features/backoffice/queries.ts";

export const Route = createFileRoute("/_app/roles")({ component: RolesScreen });

function RolesScreen() {
  const { data } = useOwnerState();
  return (
    <div className="space-y-6">
      <PageHeader
        title="Role / permission management"
        subtitle="FR-ROLE-* default matrix. Custom role editing is intentionally disabled for MVP mock."
      />
      <DataTable
        rows={data?.roles ?? []}
        getRowKey={(row) => row.role}
        columns={[
          { key: "role", header: "Role", cell: (row) => <RoleChip label={row.role} /> },
          {
            key: "perms",
            header: "Readable permissions",
            cell: (row) => (
              <div className="flex flex-wrap gap-1">
                {row.permissions.map((permission) => (
                  <StatusChip key={permission} tone="info">
                    {permission}
                  </StatusChip>
                ))}
              </div>
            ),
          },
          {
            key: "editable",
            header: "Custom editing",
            cell: (row) => (
              <StatusChip tone={row.editable ? "success" : "neutral"}>
                {row.editable ? "enabled" : "mock disabled"}
              </StatusChip>
            ),
          },
        ]}
      />
    </div>
  );
}
